import axiosIns from '@/libs/axios'

const ROOT_URL = '/fleets'

const errMsg = (error, fallback) => {
  const d = error?.response?.data
  if (d?.errors && typeof d.errors === 'object') {
    const parts = Object.entries(d.errors).map(([k, v]) => `${k}: ${[].concat(v).join(', ')}`)
    if (parts.length) return parts.join(' · ')
  }
  return d?.message || fallback
}

export default {
  namespaced: true,
  state: {
    list: [],
    flags: { runnerEnabled: false, liveEnabled: false },
    meta: null,
    templates: [],
    detail: null,
    positions: { total: 0, rows: [] },
    decisions: { counts: [], rows: [] },
    loading: false,
    busy: false,
    dataSave: { message: null, status: null },
  },
  getters: {
    list: s => s.list,
    flags: s => s.flags,
    meta: s => s.meta,
    templates: s => s.templates,
    detail: s => s.detail,
    positions: s => s.positions,
    decisions: s => s.decisions,
    loading: s => s.loading,
    busy: s => s.busy,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_LIST(state, data) {
      state.list = Array.isArray(data?.fleets) ? data.fleets : []
      state.flags = { runnerEnabled: Boolean(data?.runnerEnabled), liveEnabled: Boolean(data?.liveEnabled) }
    },
    SET_META(state, data) { state.meta = data },
    SET_TEMPLATES(state, data) { state.templates = Array.isArray(data) ? data : [] },
    SET_DETAIL(state, data) {
      state.detail = data
      if (data) state.flags = { runnerEnabled: Boolean(data.runnerEnabled), liveEnabled: Boolean(data.liveEnabled) }
    },
    SET_POSITIONS(state, data) { state.positions = data || { total: 0, rows: [] } },
    SET_DECISIONS(state, data) { state.decisions = data || { counts: [], rows: [] } },
    SET_LOADING(state, val) { state.loading = val },
    SET_BUSY(state, val) { state.busy = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getList({ commit }) {
      commit('SET_LOADING', true)
      return axiosIns.get(ROOT_URL)
        .then(r => commit('SET_LIST', r.data.data))
        .catch(e => commit('SET_DATA_SAVE', { status: false, message: errMsg(e, 'Filo listesi alınamadı.') }))
        .finally(() => commit('SET_LOADING', false))
    },
    getMeta({ commit }) {
      return axiosIns.get(`${ROOT_URL}/meta`).then(r => commit('SET_META', r.data.data)).catch(e => console.error(e))
    },
    getTemplates({ commit }) {
      return axiosIns.get(`${ROOT_URL}/templates`).then(r => commit('SET_TEMPLATES', r.data.data)).catch(e => console.error(e))
    },
    getDetail({ commit }, id) {
      return axiosIns.get(`${ROOT_URL}/${id}`)
        .then(r => commit('SET_DETAIL', r.data.data))
        .catch(e => {
          if (e?.response?.status === 404) commit('SET_DETAIL', null)
          commit('SET_DATA_SAVE', { status: false, message: errMsg(e, 'Filo detayı alınamadı.') })
        })
    },
    getPositions({ commit }, { id, params }) {
      return axiosIns.get(`${ROOT_URL}/${id}/positions`, { params }).then(r => commit('SET_POSITIONS', r.data.data)).catch(e => console.error(e))
    },
    getDecisions({ commit }, { id, params }) {
      return axiosIns.get(`${ROOT_URL}/${id}/decisions`, { params }).then(r => commit('SET_DECISIONS', r.data.data)).catch(e => console.error(e))
    },
    // preview never commits a toast: the page shows the check inline
    preview(_ctx, draft) {
      return axiosIns.post(`${ROOT_URL}/preview`, draft).then(r => r.data.data)
    },
    // mutating actions: one helper so every one of them reports success / error the same way
    run({ commit }, { method, url, body, ok, fail }) {
      commit('SET_BUSY', true)
      return axiosIns[method](`${ROOT_URL}${url}`, body)
        .then(r => {
          commit('SET_DATA_SAVE', { status: true, message: ok || r.data.message })
          if (r.data.data && r.data.data.fleet) commit('SET_DETAIL', r.data.data)
          return r.data.data
        })
        .catch(e => {
          commit('SET_DATA_SAVE', { status: false, message: errMsg(e, fail || 'İşlem başarısız.') })
          throw e
        })
        .finally(() => commit('SET_BUSY', false))
    },
    createDefault({ dispatch }) {
      return dispatch('run', { method: 'post', url: '/default', ok: 'Standart Filo oluşturuldu.', fail: 'Standart Filo oluşturulamadı.' })
    },
    create({ dispatch }, draft) {
      return dispatch('run', { method: 'post', url: '', body: draft, ok: 'Filo oluşturuldu (Taslak).', fail: 'Filo oluşturulamadı.' })
    },
    update({ dispatch }, { id, patch }) {
      return dispatch('run', { method: 'patch', url: `/${id}`, body: patch, ok: 'Ayarlar kaydedildi.', fail: 'Ayarlar kaydedilemedi.' })
    },
    remove({ dispatch }, id) {
      return dispatch('run', { method: 'delete', url: `/${id}`, ok: 'Filo silindi.', fail: 'Filo silinemedi.' })
    },
    setStatus({ dispatch }, { id, action }) {
      const ok = {
        start: 'Filo başlatıldı. İlk işlem bir sonraki mum kapanışında.', pause: 'Filo duraklatıldı.', stop: 'Filo durduruldu.', kill: 'Acil kapatma başlatıldı.',
      }[action]
      return dispatch('run', {
        method: 'post', url: `/${id}/${action}`, body: action === 'kill' ? { confirm: true } : undefined, ok, fail: 'Durum değiştirilemedi.',
      })
    },
  },
}
